// Regras de tela do carrinho (itens do lead no ERP). As de negócio moram no ERP; aqui só o
// que a modal decide sozinha: formatação, quando gravar e o que refazer depois de uma decisão.

const moeda = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

export const formatarMoeda = (valor) => moeda.format(Number(valor) || 0);

export const formatarQtd = (valor, casas = 0) =>
	new Intl.NumberFormat("pt-BR", { minimumFractionDigits: 0, maximumFractionDigits: casas }).format(Number(valor) || 0);

// Campo vazio não grava; só manda quando o número mudou de fato (o blur sem edição não é alteração).
export const valorAlterado = (original, digitado) => {
	if (digitado === "" || digitado === null || digitado === undefined) return false;
	const novo = Number(String(digitado).replace(",", "."));
	if (Number.isNaN(novo)) return false;
	return novo !== Number(original);
};

export const numeroDigitado = (digitado) => Number(String(digitado).replace(",", "."));

export const textoPagamento = (pagamento) => {
	if (!pagamento || !pagamento.planoNome) return "";
	const forma = pagamento.forma === "A" ? "À vista" : "A prazo";
	return `${forma} — ${pagamento.planoNome} em ${pagamento.qtdParcelas}x`;
};

// Toda promoção com brinde precisa de Sim/Não antes de aplicar, como na modal do lead.
export const brindesDecididos = (promocoes, escolhas) =>
	(promocoes || []).every((p) => !p.existeProdPromocional || typeof (escolhas || {})[p.id] === "boolean");

// O que fazer com a resposta à decisão que o ERP devolveu: qual "promocao" gravar antes (ou nenhuma)
// e com que dados refazer a ação que parou. null = só fechar.
export const respostaDaDecisao = (decisao, escolha, { acao, dados } = {}) => {
	const refazer = (extra) => ({ acao, dados: { ...(dados || {}), ...extra } });
	switch (decisao && decisao.tipo) {
		case "PROMOCAO_ATINGIDA":
			if (escolha === "APLICAR") {
				return {
					promocao: { tipo: "APLICAR", produtoPromocional: decisao.brindes || {} },
					...refazer({ promocaoDecidida: true }),
				};
			}
			if (escolha === "NAO_APLICAR") return { promocao: null, ...refazer({ promocaoDecidida: true }) };
			return null;
		case "PROMOCAO_NAO_ATINGIDA":
			return escolha === "REAJUSTAR" ? { promocao: { tipo: "RETIRAR" }, ...refazer({}) } : null;
		case "PROMOCIONAL_DESATUALIZADO":
			return escolha === "REAJUSTAR" ? { promocao: { tipo: "AJUSTAR" }, ...refazer({}) } : null;
		case "NOVA_OS":
			return escolha === "SIM" ? { promocao: null, ...refazer({ confirmarNovaOs: true }) } : null;
		case "WHATS_DESCONECTADO":
			return escolha === "GERAR_PDF" ? { promocao: null, acao: "gerarCotacao", dados: {} } : null;
		default:
			return null;
	}
};

// O campo de data do navegador fala "yyyy-MM-dd"/"yyyy-MM-ddTHH:mm"; o ERP devolve "yyyy-MM-ddTHH:mm:ss".
export const paraCampoData = (valor) => (valor ? String(valor).substring(0, 10) : "");
export const paraCampoDataHora = (valor) => (valor ? String(valor).substring(0, 16) : "");

export const formatarDataHora = (valor) => {
	if (!valor) return "";
	const [data, hora] = String(valor).split("T");
	const [ano, mes, dia] = data.split("-");
	return hora ? `${dia}/${mes}/${ano} ${hora.substring(0, 5)}` : `${dia}/${mes}/${ano}`;
};

// "Marcar todos" da lista com busca, como o selectCheckboxMenu do ERP: age só sobre o que o filtro
// está mostrando. Todos visíveis marcados = desmarca esses; senão marca os que faltam.
export const alternarTodos = (valores, idsVisiveis) => {
	const marcados = valores || [];
	const visiveis = idsVisiveis || [];
	if (visiveis.length > 0 && visiveis.every((id) => marcados.includes(id))) {
		return marcados.filter((id) => !visiveis.includes(id));
	}
	return [...marcados, ...visiveis.filter((id) => !marcados.includes(id))];
};
